import * as React from 'react';
import { InlineText2, Header1 } from '@cian/ui-kit/typography';
import { Layout } from '../Layout';
import * as style from './Address.css';

interface IAddressProps {
  fullAddress: string;
  underground: React.ReactNode;
  roads: React.ReactNode;
  mapPreview: React.ReactNode;
}

export function Address({ fullAddress, underground, roads, mapPreview }: IAddressProps) {
  return (
    <Layout>
      <div className={style['container']}>
        <div>
          <InlineText2 color={'gray60_100'}>Местоположение</InlineText2>
          <div className={style['full-address']}>
            <Header1>{fullAddress}</Header1>
          </div>
          <div className={style['stations']}>
            {underground}
            {roads}
          </div>
        </div>
        <div className={style['map']}>{mapPreview}</div>
      </div>
    </Layout>
  );
}
